<template>
  <div class="mobile">
    <video autoplay muted loop id="myVideo">
      <source src="../assets/background.mp4" type="video/mp4" />
      Your browser does not support HTML5 video.
    </video>
  </div>
</template>

<style scoped>
#myVideo {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
}
@media only screen and (max-width: 1280px) {
}
@media only screen and (max-width: 600px) {
#myVideo {
  display: none;
}
}
</style>

<script>
export default {
  name: "Background-video",
  mounted: {
    video() {
      var video = document.getElementById("myVideo");
      var btn = document.getElementById("myBtn");
      if (video.paused) {
        video.play();
        btn.innerHTML = "Pause";
      } else {
        video.pause();
        btn.innerHTML = "Play";
      }
    },
  },
};
</script>